import { ChatConversation } from '@/features/chat/types';
import { create } from 'zustand';

interface ConversationStore {
    conversations: ChatConversation[];
    addConversation: (conversation: ChatConversation) => void;
    updateConversationTitle: (id: string, title: string) => void;
    setPendingState: (id: string, isPending: boolean) => void;
    setConversations: (conversations: ChatConversation[]) => void;
}

export const useConversationStore = create<ConversationStore>((set, _get) => ({
    conversations: [],

    addConversation: (conversation: ChatConversation) =>
        set(state => ({
            conversations: [conversation, ...state.conversations],
        })),

    updateConversationTitle: (id: string, title: string) =>
        set(state => ({
            conversations: state.conversations.map(conversation =>
                conversation.id === id ? { ...conversation, title, isPending: false } : conversation
            ),
        })),

    setPendingState: (id: string, isPending: boolean) =>
        set(state => ({
            conversations: state.conversations.map(conversation =>
                conversation.id === id ? { ...conversation, isPending } : conversation
            ),
        })),

    setConversations: (conversations: ChatConversation[]) => set({ conversations }),
}));
